export default "__VITE_ASSET__b35de7f8__"